import { captureException } from '@sentry/nextjs'
import { ZodError } from 'zod/v4'

export const catchWithSentryCapture = <TFallback>(
  fallbackValue: TFallback,
  schemaName: string
) => {
  return (context: { error: unknown; input: unknown }): TFallback => {
    const { error, input } = context

    let fieldPath = 'unknown field'
    let originalErrorMessage = 'Unknown error'

    if (error instanceof ZodError) {
      if (error.issues.length > 0) {
        const details = error.issues.map(
          (issue) =>
            `${issue.path.join('.') || 'unknown field'}: ${issue.message}`
        )
        fieldPath = error.issues
          .map((issue) => issue.path.join('.') || 'unknown field')
          .join(', ')
        originalErrorMessage = details.join('; ')
      } else {
        originalErrorMessage = 'Zod validation error'
      }
    } else if (error instanceof Error) {
      originalErrorMessage = error.message
    } else {
      originalErrorMessage = String(error)
    }

    const errorMessage = `Unexpected value in schema "${schemaName}" at field "${fieldPath}" (unexpected value: ${JSON.stringify(input)}). Original error: ${originalErrorMessage}`

    captureException(
      new Error(errorMessage, {
        cause: error instanceof Error ? error : undefined,
      })
    )
    return fallbackValue
  }
}
